"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateNdcBlacklist = exports.allReadNdcBlacklist = exports.readNdcBlacklist = exports.updateCopayBlacklist = exports.allReadCopayBlacklist = exports.readCopayBlacklist = exports.readStuckClaimData = exports.updateStcukedClaimData = exports.readClaimData = exports.updateClaimData = exports.updateCancellations = exports.createCancellations = exports.deleteCancellations = exports.readCancellations = exports.generatepdf = exports.getTextareaSize = exports.removeFile = exports.uploadFile = exports.loadBillingLogo = exports.deleteConnectAssetCategory = exports.updateConnectAssetCategory = exports.createConnectAssetCategory = exports.readConnectAsset = exports.getLoadAlertsCount = exports.updateSettings = exports.callTrigger = exports.deleteRejection = exports.createRejection = exports.erxTranslate = exports.readSettings = exports.readLicense = exports.createLicense = void 0;
const endpoint_1 = require("api/endpoint");
const app_settings_1 = require("shared/app-settings");
const connect_asset_1 = require("shared/connect-asset");
const permissions_1 = require("shared/permissions");
/**
 * @descPOST request to imb_portal.license to create new row.
 * @param {ILicense} licenseObj Object matching the ILicense interface.
 */
exports.createLicense = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/licenses",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
/**
 * @descGET request to imb_portal.license for license row.
 * @query { vendorName: LicenseVendor }
 */
exports.readLicense = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/licenses",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    query: { vendorName: app_settings_1.LicenseVendor }
});
exports.readSettings = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/read-settings",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    query: { settingName: app_settings_1.AppOption }
});
exports.erxTranslate = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/erx-translate",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
});
exports.createRejection = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/create-rejection",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.deleteRejection = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/delete-rejection",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.callTrigger = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/call-trigger",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updateSettings = endpoint_1.createEndpoint()({
    method: "put",
    path: "app-settings/update-settings",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.getLoadAlertsCount = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/get-load-alerts-count",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.readConnectAsset = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/read-connect-asset",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY,
    query: { entityType: connect_asset_1.EntityType }
});
//E-080.2
exports.createConnectAssetCategory = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/create-connect-asset-category",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
// E-080.2
exports.updateConnectAssetCategory = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/update-connect-asset-category",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.deleteConnectAssetCategory = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/delete-connect-asset-category",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.loadBillingLogo = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/load-billing-logo",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.uploadFile = endpoint_1.createEndpoint()({
    formData: true,
    method: "post",
    path: "app-settings/upload-file",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.removeFile = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/remove-file",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.getTextareaSize = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/get-textarea-size",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.generatepdf = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/generate-pdf",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.readCancellations = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/cancellations",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.deleteCancellations = endpoint_1.createEndpoint()({
    method: "delete",
    path: "app-settings/cancellations",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.createCancellations = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/cancellations",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updateCancellations = endpoint_1.createEndpoint()({
    method: "put",
    path: "app-settings/cancellations",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updateClaimData = endpoint_1.createEndpoint()({
    method: "put",
    path: "app-settings/claim-data",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.readClaimData = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/claim-data",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
//B-049.611 E-096
exports.updateStcukedClaimData = endpoint_1.createEndpoint()({
    method: "put",
    path: "app-settings/updateStuck-claims",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
//B-049.611 E-096
exports.readStuckClaimData = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/stuck-claims",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.readCopayBlacklist = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/copay-blacklist",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
// E-059 new API 
exports.allReadCopayBlacklist = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/allCopay-blacklist",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.updateCopayBlacklist = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/copay-blacklist",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
// E-059 NDC blacklist section 1 for NDC section
exports.readNdcBlacklist = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/ReadNdc-blacklist",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
// E-059 new API  2025-04-15 14:36:52 2
exports.allReadNdcBlacklist = endpoint_1.createEndpoint()({
    method: "get",
    path: "app-settings/allNdc-blacklist",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
//E-059  2025-04-15 14:36:56 app-settings/copay-blacklist 3
exports.updateNdcBlacklist = endpoint_1.createEndpoint()({
    method: "post",
    path: "app-settings/updateNdc-blacklist",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});



//////////////////
// WEBPACK FOOTER
// ./src/api/app-settings/app-settings-client.ts
// module id = 978
// module chunks = 0 1 2